module.exports = __webpack_public_path__ + "static/media/hit_house.6d398508.svg";